<template>
    <div class="container">
        <form @submit.prevent="sendEmail">
            <div class="row justify-content-center">

                <div class="col-xxl-10">
                    <div class="bg-green-light p-4 p-xl-5">

                        <div class="row">
                            <div class="col-12 text-center mb-5">
                                <slot name="first-slot"></slot>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6 mb-3">
                                <slot name="second-slot"></slot>
                                <div class="row">
                                    <div class="col-12">
                                        <input type="email" name="email" id="email" class="form-control form-control-lg" placeholder="Email" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="email">
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 mb-3">
                                <slot name="third-slot"></slot>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12 text-center mt-3 mb-1">
                                <button type="submit" class="btn btn-black px-5" :disabled="isButtonDisabled"><span>INVIA IL MESSAGGIO</span> <i class="fas fa-circle-notch fa-spin lh-1-2 ms-2" :class="{'d-none': !isButtonDisabled}"></i></button>
                            </div>
                            <div class="col-12 text-center">
                                {{formMsg}}
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            ajaxObj: window.ajax_object,
            email: '',
            isButtonDisabled: false,
            formMsg: ''
        }
    },

    methods: {
        sendEmail() {
            this.isButtonDisabled = true
			let url = this.ajaxObj.ajax_url

			let formData = new FormData();
			formData.append('action', 'nl_send_invitation')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('email', this.email)

			axios.post(url, formData)
				.then((response) => {
					console.log(response.data)
                    this.isButtonDisabled = false
					if(response.data.error == '') {
                        this.email = ''
						this.formMsg = response.data.msg
					}
				}, (error) => {
                    this.isButtonDisabled = false
					console.log(error);
				});
        }
    }
}
</script>